import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Title } from 'smartsuite-ui';

export default function BagSummaryHeaderSkeleton() {
    return (
        <div className="bag-summary-header">
            <div className="bag-summary-header__top">
                <Title>Bag Summary</Title>
            </div>
            <div className="bag-summary-header__bottom">
                <Skeleton
                    variant="rect"
                    animation="wave"
                    width="100%"
                    height="54px"
                />
            </div>
        </div>
    );
}
